import * as z from "zod";
import { null as zNull } from "zod";

export const getShopifyMarkets = {
  name: "getShopifyMarkets" as const,
  input: zNull(),
  output: z.object({
    shopifyMarkets: z.array(
      z.object({
        id: z.string(),
        handle: z.string(),
        status: z.enum(["ACTIVE", "DRAFT"]),
        countryCodes: z.array(z.string()),
        isRedoOwned: z.boolean(),
      }),
    ),
  }),
};
